import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const DISCLAIMER_SHORT =
  "Workflow assistant only. Not legal, financial, or banking advice. Output is non-binding — always confirm with your bank.";
